import styled from 'styled-components';
import { Button } from '@bynder/design-system';

export const TransformButton = styled(Button)`
    max-width: 44px;
`;
